App.vue.setComponent(require('@components/sliders/MainSlider').default);
App.vue.setComponent(require('@components/Promo/PromoSlider/PromoSlider').default);
App.vue.setComponent(require('@components/sliders/NewGoods').default);
App.vue.setComponent(require('@components/Categories/Categories').default);
App.vue.setComponent(require('@components/Moments/Moments.vue').default);
